/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResponseOfAuditEntryItem } from '../../models/paged-response-of-audit-entry-item';

export interface AuditSearch$Json$Params {
  From?: string;
  To?: string;
  ActorUserId?: string;
  Action?: string;
  SubjectType?: string;
  SubjectId?: string;
  Module?: string;
  Page?: (number | string);
  PageSize?: (number | string);
  Sort?: string;
  Q?: string;
  Filter?: {
[key: string]: string;
};
}

export function auditSearch$Json(http: HttpClient, rootUrl: string, params?: AuditSearch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResponseOfAuditEntryItem>> {
  const rb = new RequestBuilder(rootUrl, auditSearch$Json.PATH, 'get');
  if (params) {
    rb.query('From', params.From, {});
    rb.query('To', params.To, {});
    rb.query('ActorUserId', params.ActorUserId, {});
    rb.query('Action', params.Action, {});
    rb.query('SubjectType', params.SubjectType, {});
    rb.query('SubjectId', params.SubjectId, {});
    rb.query('Module', params.Module, {});
    rb.query('Page', params.Page, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Sort', params.Sort, {});
    rb.query('Q', params.Q, {});
    rb.query('Filter', params.Filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResponseOfAuditEntryItem>;
    })
  );
}

auditSearch$Json.PATH = '/api/v1/platform/audit';
